export default "__VITE_ASSET__C$ttemJ6__"